import React from 'react';
import { Statistic, Popover } from 'antd';
import { Group } from 'antd/lib/avatar';
import { FaInfoCircle } from 'react-icons/fa';
import formatterPrice from '@/utils/number/formatterPrice';

interface CustomStatisticProps {
  title: string;
  description: string;
  value?: number;
  valueStyle?: React.CSSProperties;
  iconSize?: number;
}

const CustomStatistic: React.FC<CustomStatisticProps> = ({
  title,
  description,
  value,
  valueStyle,
  iconSize = 16,
}) => {
  return (
    <Statistic
      title={
        <Group>
          {title}{' '}
          <Popover title={title} content={<code>{description}</code>}>
            <FaInfoCircle
              size={iconSize}
              style={{ marginLeft: 8, cursor: 'pointer' }}
            />
          </Popover>
        </Group>
      }
      value={value ?? 0}
      formatter={(value) => formatterPrice(Number(value))}
      valueStyle={valueStyle}
    />
  );
};

export default CustomStatistic;
